import { useQuery } from '@apollo/client/react';
import { logError } from 'fergy-core-react-logging';
import { type FunctionComponent } from 'react';
import type { RelatedQueriesQuery, RelatedQueriesQueryVariables } from '../../../__generated__/graphql-client-types';
import { useRouterLocation } from '../../../hooks/routing/location.hook';
import { RELATED_QUERIES } from '../../../queries/search/search.queries';
import { doesWindowExist } from '../../../utils/dom/dom.utils';
import { Link } from '../../common-components/link/link.component';
import { relatedQueryPill } from './similar-searches.css';

export const SimilarSearches: FunctionComponent = () => {
	const { search } = useRouterLocation();
	const queryParams = new URLSearchParams(search);
	const query = queryParams.get('term') || '';

	const { data, error } = useQuery<RelatedQueriesQuery, RelatedQueriesQueryVariables>(RELATED_QUERIES, {
		variables: { query },
		ssr: doesWindowExist()
	});

	if (error) {
		logError(error.message, error);
	}

	return data?.relatedQueries?.length ? (
		<>
			<div className="f4 lh-title b mt4 mb2">Related Searches</div>
			<div className="mt2 flex flex-wrap justify-between db-ns">
				{data.relatedQueries.map((term, index) => (
					<Link
						url={term.url}
						className={`${relatedQueryPill} lh-title pv2 ph3 mb2 br2 bg-theme-grey-light b--theme-grey-light flex items-center justify-center min-h3 mr2-ns dib-ns min-h0-ns`}
						textAlign={'tc'}
						color="grey-darker"
						key={`${term.name}-${index}`}
						analyticsHook="similar-search">
						{term.name}
					</Link>
				))}
			</div>
		</>
	) : null;
};
